import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
//
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import IconButton from "@mui/material/IconButton";
import validator from "validator";
//
import { StoreContext } from "../../../../../../store/StoreProvider";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import AvatarBasic from "../../../../../../common/components/avatar/AvatarBasic";
import ListItemBasic from "../../../../../../common/components/listitem/ListItemBasic";
import TooltipBasic from "../../../../../../common/components/tooltip/TooltipBasic";
import IconInvite from "../../../../../../../images/icon_invite/icon_invite.svg";
// config, utils
import urls from "../../../../../../api/project/ApiUrls";
import fstDb from "../../../../../../api/firebase/firestore/utils";
//
import { sentGroupInvitation } from "../../../../service/userGroupService";
import { generateInvitationToGroup } from "../../../../../../config/config.invite";
import Act from "../../../../../../store/actions";
import { ROUTE_PATH } from "../../../../../../config/CONSTANTS";

const UserListItem = ({ user, role }) => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user: globalUser } = state;
  const { locale, group } = globalUser;
  // local state
  const [isLoading, setIsLoading] = useState(false);

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  // 未滿足條件(選取角色及 email),則 disabled
  const disabledSendEmail = () =>
    !(role && user && user?.email && validator.isEmail(user.email)) ||
    isLoading;

  const getListItemBasicProps = () => {
    const customProps = {};
    if (user.displayName) {
      return {
        ...customProps,
        listIcon: <AvatarBasic avatarProps={{ letter: user.displayName }} />,
        textPrimary: user.displayName,
        textSecondary: user.email,
      };
    }
    return {
      ...customProps,
      textPrimary: user.email,
      textSecondary: "by email",
    };
  };

  const onClickInvite = async () => {
    try {
      if (
        !(
          globalUser?.uid &&
          globalUser?.email &&
          user?.email &&
          role &&
          group.uid
        )
      ) {
        console.error(
          "globalUser?.uid && globalUser?.email && user?.email && role && group.uid is required"
        );
        return;
      }
      dispatch({
        type: Act.COMMON_SET_INFO_MESSAGE,
        payload: {
          open: true,
          content: "Sending invitation email to user...",
        },
      });
      setIsLoading(true);

      // firestore create invitation
      const createInfo = await fstDb.postInviteInfo(
        { role, uid: group.uid, displayName: group.displayName },
        {
          uid: globalUser.uid,
          email: globalUser.email,
          displayName: globalUser.displayName,
        },
        { email: user.email }
      );
      if (createInfo.success && createInfo?.data?.uid) {
        // 寄送邀請信
        const mailTemplate = generateInvitationToGroup(
          {
            email: globalUser.email,
            name: globalUser?.displayName,
          },
          {
            email: user.email,
          },
          `${process.env.REACT_APP_WEB_DOMAIN}${handleLocaleRoute(
            ROUTE_PATH.InvitePage
          )}?inviteid=${createInfo?.data?.uid}`,
          {
            displayName: group.displayName,
          }
        );
        if (!mailTemplate) {
          console.error("Fail to generate mail template");
          return;
        }

        const sentMailRes = await sentGroupInvitation(mailTemplate);

        if (sentMailRes.success) {
          // display success message
          dispatch({
            type: Act.COMMON_SET_SUCCESS_MESSAGE,
            payload: {
              open: true,
              content: "Invitation email sent successfully",
            },
          });
          setIsLoading(false);
        } else {
          console.error(sentMailRes.error);
          // display error message
          dispatch({
            type: Act.COMMON_SET_ERROR_MESSAGE,
            payload: {
              open: true,
              content: "Fail to send email invitation",
            },
          });
          setIsLoading(false);
        }
      } else {
        console.log(createInfo.error);
        // display error message
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: "Fail to send email invitation",
          },
        });
        setIsLoading(false);
      }
    } catch (e) {
      //
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: "Fail to send email invitation",
        },
      });
      setIsLoading(false);
    }
  };

  return (
    user && (
      <ListItemBasic
        {...getListItemBasicProps()}
        listItemProps={{
          secondaryAction: (
            <TooltipBasic
              tooltipProps={{
                title: "invite",
                className: "tool-tip",
              }}
            >
              <IconButton
                onClick={onClickInvite}
                disabled={disabledSendEmail()}
              >
                <img src={IconInvite} alt="invite icon" />
              </IconButton>
            </TooltipBasic>
          ),
        }}
        listItemButtonProps={{
          onClick: () => null,
          disabled: disabledSendEmail(),
        }}
        listItemTextProps={{
          sx: {
            "& span": {
              fontSize: "14px",
            },
            "& p": {
              fontSize: "12px",
            },
          },
        }}
      />
    )
  );
};

UserListItem.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  role: PropTypes.string,
};

UserListItem.defaultProps = {
  user: {},
  role: null,
};

export default UserListItem;
